// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { validateNumberRange } from 'validators/common'

const validate = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  const err = {}

  const isAdvSearch = v.advancedSearch.length

  if (v.bandwidth.length) {
    validateNumberRange(v.bandwidth, err, 'bandwidth')
  }

  if (v.frequency.length) {
    validateNumberRange(v.frequency, err, 'frequency')
  }

  if (isAdvSearch && v['adv-throughput'].length) {
    validateNumberRange(v['adv-throughput'], err, 'adv-throughput')
  }

  return err
}

export default validate
